export const userInfo = state => {
    console.log('state is ', JSON.stringify(state));
    return state.userInfo
}
export const token = state => state.token
export const hasLogin = state => state.hasLogin

